import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { ESelectedEntityType } from '@common/types/layout.type';

import { LayoutFacade } from '@web/store/layout/layout.facade';

import WidgetsLegacyActions, { WidgetsActions } from '@web/store/page-structure/widgets/widgets.actions';
import LayoutActions from '@web/store/layout/layout.actions';

@Injectable()
export class LayoutEffects {
    private readonly actions$ = inject(Actions);
    private readonly layoutFacade = inject(LayoutFacade);

    // private readonly setBlockSelected$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(BlocksActions.blockCreated),
    //         map(({ block }) =>
    //             LayoutActions.setSelectedEntity({
    //                 selectedEntity: {
    //                     entityId: block.id,
    //                     entityType: ESelectedEntityType.block,
    //                 },
    //             }),
    //         ),
    //     ),
    // );
    //
    // private readonly setColumnSelected$ = createEffect(() =>
    //     this.actions$.pipe(
    //         ofType(ColumnsActions.columnCreated),
    //         map(({ column }) =>
    //             LayoutActions.setSelectedEntity({
    //                 selectedEntity: {
    //                     entityId: column.id,
    //                     entityType: ESelectedEntityType.column,
    //                 },
    //             }),
    //         ),
    //     ),
    // );

    private readonly setSelectedEntity$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(LayoutActions.setSelectedEntity),
                filter(({ scrollTo }) => scrollTo),
                map(({ selectedEntity }) => {
                    const element = document.getElementById(selectedEntity.entityId);
                    if (!element) {
                        console.warn(
                            'Element not found. ID =',
                            selectedEntity.entityId,
                            'Type =',
                            selectedEntity.entityType
                        );
                        return;
                    }

                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                })
            ),
        { dispatch: false }
    );

    private readonly setWidgetSelected$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WidgetsLegacyActions.widgetCreated, WidgetsActions.created),
            map(({ widget }) =>
                LayoutActions.setSelectedEntity({
                    selectedEntity: {
                        entityId: widget.id,
                        entityType: ESelectedEntityType.widget,
                    },
                })
            )
        )
    );

    private readonly unsetWidgetSelected$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WidgetsLegacyActions.removeWidget, WidgetsActions.removed),
            filter(({ skipUnselectEntity }) => !skipUnselectEntity),
            map(() => LayoutActions.unsetEntity())
        )
    );

    public readonly unsetWidgetSelectedFromMany$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WidgetsLegacyActions.removeManyWidgets),
            withLatestFrom(this.layoutFacade.selectedEntity$, ({ widgetsIds }, selectedEntity) => ({
                widgetsIds,
                selectedEntity,
            })),
            filter(
                ({ widgetsIds, selectedEntity }) =>
                    selectedEntity?.entityType === ESelectedEntityType.widget &&
                    widgetsIds.includes(selectedEntity.entityId)
            ),
            map(() => LayoutActions.unsetEntity())
        )
    );
}
